import Colors from "@src/constants/Colors";
import { FC } from "react";

interface EllipseType {
  color?: string;
  width?: string;
  height?: string;
}

const Ellipse: FC<EllipseType> = ({ color, width, height }) => {
  return (
    <svg
      width={width || "4"}
      height={height || "4"}
      viewBox="0 0 4 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="2" cy="2" r="2" fill={color} />
    </svg>
  );
};

Ellipse.defaultProps = {
  color: Colors.neutralblack,
  width: "4",
  height: "4",
};

export default Ellipse;
